import { authClient, API } from '../index'

// Count all literals
export const countLiterals = () => {
  return authClient().get(`${API}/literal/count`)
}

// Get all literals
export const getLiterals = () => {
  return authClient().get(`${API}/literal`)
}

// Get literal by id
export const getLiteralById = (id) => {
  return authClient().get(`${API}/literal/id/${id}`)
}

// Get literal by nombre
export const getLiteralByNombre = (nombre) => {
  return authClient().get(`${API}/literal/nombre/${nombre}`)
}

// Update literal by id
export const updateLiteral = (id, literal) => {
  return authClient().put(`${API}/literal/${id}`, literal)
}

// Update literal by nombre
export const updateLiteralByNombre = (nombre, literal) => {
  return authClient().put(`${API}/literal/nombre/${nombre}`, literal)
}

// Create literal
export const postLiteral = (literal) => {
  return authClient().post(`${API}/literal`, literal)
}

// Delete literal
export const deleteLiteral = (id) => {
  return authClient().delete(`${API}/literal/${id}`)
}
